import React, { useState } from 'react';
import AudioPlayer from './AudioPlayer';
import SimpleDemoModal from './SimpleDemoModal';
import { trackScheduleDemoClick } from '../utils/analytics';

const Hero: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black pt-32 pb-12">

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center max-w-6xl mx-auto">
          {/* Main Headline */}
          <div className="animate-fadeInUp mb-8">
            <h1 className="font-bold tracking-tight text-white">
              <div className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl mb-2">
                AI That Calls
              </div>
              <div className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl mb-2">
                Your{' '}
                <span className="text-primary-400">Candidates</span>
              </div>
            </h1>
          </div>

          {/* Subheadline */}
          <div className="animate-fadeInUp mb-8" style={{ animationDelay: '0.1s' }}>
            <p className="text-base text-gray-300 max-w-4xl mx-auto leading-relaxed">
              Vertex Find's AI reads resumes, scores candidates, and calls them to schedule interviews — automatically. Save hours every week with AI that handles the screening and scheduling for you.
            </p>
          </div>


          {/* Audio Player */}
          <div className="animate-fadeInUp mb-6" style={{ animationDelay: '0.2s' }}>
            <AudioPlayer src="/recording.wav" />
          </div>

          {/* Call-to-Action */}
          <div className="animate-fadeInUp" style={{ animationDelay: '0.3s' }}>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-4">
              <button 
                className="btn-primary px-10 py-4 text-lg"
                onClick={() => {
                  trackScheduleDemoClick('hero_section', { 
                    cta_type: 'primary_hero_button',
                    button_size: 'large'
                  });
                  setIsModalOpen(true);
                }}
              >
                Schedule Demo →
              </button>
              {/* <button className="btn-secondary px-10 py-4 text-lg">
                Book a Call
              </button> */}
            </div>
            
            {/* Trust Indicators */}
            <div>
              <p className="text-sm text-gray-400">
                No credit card required • 5 day free trial • Cancel anytime
              </p>
            </div>
          </div>

        </div>
      </div>


      {/* Demo Modal */}
      <SimpleDemoModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)}
        modalType="demo"
      />
    </section>
  );
};

export default Hero; 